import { Services, checkHostnames, projectName } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'

import { globalErrorHandler, macroCacheOptions, productionHostnames, request } from '@/utils'

import render from './render'

const Cache = new Macro(macroCacheOptions)

const cachedGet = Cache.wrapWithCache(async (key, path) => {
  return await request.find(path)
})

export default {
  name: 'Counter',

  data() {
    return {
      count: 0,
      interval: undefined
    }
  },

  computed: {
    canGetSendingsModeration() {
      return this.checkPermissions(`advanced.${Services.sendingsModeration}.get`)
    }
  },

  mounted() {
    this.getCount()
    this.interval = setInterval(this.getCount, 5 * 1000)
  },

  beforeDestroy() {
    clearInterval(this.interval)
  },

  methods: {
    async getCount() {
      if (checkHostnames(productionHostnames)) {
        if (this.canGetSendingsModeration) {
          try {
            const endpoint = 'count'
            const key = [ projectName, Services.sendingsModeration, 'find', endpoint ].filter(Boolean).join(':')
            const pathToApi = [ Services.sendingsModeration, Services.sendings, endpoint ].join('/')
            const data = await cachedGet(key, pathToApi)
            if (data && data.result) {
              const count = parseInt(data.result)
              if (!isNaN(count)) {
                this.count = count
              }
            }
          } catch (error) {
            globalErrorHandler(error)
          }
        }
      }
    }
  },

  render
}
